export default __webpack_public_path__ + "static/media/linkedin.d4f5c6fb.png";